import { v4 as uuid } from 'uuid';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { renderIf } from 'typescript/utils/render-if';
import { spreadClassNames } from 'typescript/utils/spread-classnames';

import './style.scss';

function PandaCheck({
  className,
  checked = false,
  disabled = false,
  partial = false,
  children,
  onChange,
}) {
  const [id] = useState(uuid());
  const classNames = spreadClassNames('panda-check', className);

  return (
    <div
      className={classNames('', {
        '--disabled': disabled,
        '--partial': partial,
        '--with-text': children,
      })}
    >
      <input
        id={id}
        disabled={disabled}
        className={classNames('__input')}
        type="checkbox"
        checked={checked}
        onChange={onChange}
      />
      <label htmlFor={id} className={classNames('__label')}>
        {renderIf(children, () => (
          <span className={classNames('__label__content')}>{children}</span>
        ))}
      </label>
    </div>
  );
}

PandaCheck.displayName = 'PandaCheck';

PandaCheck.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  partial: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default PandaCheck;
